<template>
  <main class="main">
    <div class="hero-section-container">
      <img src="../img/hero1.png" class="bg" />
      <img src="../img/isec.webp" class="hero-right-image" />
      <div class="section hero-section">
        <div class="wrapper">
          <div class="hero-content">
            <div
              :class="[
                'title hero-title',
                { active: $parent.heroImagesLoaded },
              ]"
            >
              WELCOME TO RADGRIND, A FAST, FAIR, AND<br />COMMUNITY-DRIVEN RUST
              SERVER.
            </div>
            <div
              :class="['desc hero-desc', { active: $parent.heroImagesLoaded }]"
            >
              Squad up, sharpen your skills with our guides, jump into<br />events,
              and kit out your character with exclusive in-game<br />items from
              our shop.
            </div>
            <router-link
              to="/products"
              :class="[
                'button hero-button',
                { active: $parent.heroImagesLoaded },
              ]"
            >
              OPEN THE SHOP
            </router-link>
          </div>
          <div
            :class="['ip-container', { active: $parent.heroImagesLoaded }]"
            v-if="$parent.ip && $parent.port"
          >
            <span class="status-dot"></span>
            <span class="ip-label">SERVER IP:</span>
            <div class="desc">
              <b> {{ $parent.ip + ":" + $parent.port }}</b>
            </div>
            <button
              class="button black"
              v-clipboard="$parent.ip + ':' + $parent.port"
              v-clipboard:success="clipboardSuccessHandler"
            >
              <span>{{ copied ? "COPIED" : "COPY" }}</span>
              <img src="../img/copy.svg" class="img" />
            </button>
          </div>
        </div>
      </div>
      <img src="../img/heromenu.svg" class="hero-menu-image" />
    </div>

    <div class="section why-play-section" id="why-play">
      <div class="wrapper">
        <div class="title why-play-title">
          <img src="../img/Polygon2.svg" class="why-play-arrow-left" />
          <img src="../img/Polygonhead.svg" class="why-play-arrow-left" />
          WHY PLAY ON RADGRIND?
          <img src="../img/Polygonhead.svg" class="why-play-arrow-right" />
          <img src="../img/Polygon2.svg" class="why-play-arrow-right" />
        </div>
        <div class="why-play-list">
          <div class="why-play-item">
            <div class="why-play-panel">
              <div class="why-play-title-small">
                OPTIMIZED PERFORMANCE, MINIMAL LAG
              </div>
              <div class="why-play-desc">
                Modern hardware, smart server configs, and active monitoring
                keep fights smooth and<br />stable.
              </div>
            </div>
          </div>
          <div class="why-play-item">
            <div class="why-play-panel">
              <div class="why-play-title-small">
                ACTIVE MODERATION AND FAIR PLAY
              </div>
              <div class="why-play-desc">
                Zero tolerance for cheats and exploits.
              </div>
            </div>
          </div>
          <div class="why-play-item">
            <div class="why-play-panel">
              <div class="why-play-title-small">BALANCED CUSTOM FEATURES</div>
              <div class="why-play-desc">
                Tailored loot, curated plugins, and thoughtful progression that
                respect Rust's core<br />challenge.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section how-to-get-started-section" id="how-to-get-started">
      <div class="wrapper">
        <div class="how-to-get-started-title">
          <img
            src="../img/Polygon2.svg"
            class="how-to-get-started-arrow-left"
          />
          <img
            src="../img/Polygonhead.svg"
            class="how-to-get-started-arrow-left"
          />
          HOW TO GET STARTED (IT'S QUICK)
          <img
            src="../img/Polygonhead.svg"
            class="how-to-get-started-arrow-right"
          />
          <img
            src="../img/Polygon2.svg"
            class="how-to-get-started-arrow-right"
          />
        </div>
        <div class="how-to-get-started-progress">
          <div class="progress-line"></div>
          <div
            class="progress-circle"
            :class="{ active: activeStep === 1 }"
            @click="showStep1Images"
          >
            <span>1</span>
          </div>
          <div
            class="progress-circle"
            :class="{ active: activeStep === 2 }"
            @click="showStep2Images"
          >
            <span>2</span>
          </div>
          <div
            class="progress-circle"
            :class="{ active: activeStep === 3 }"
            @click="showStep3Images"
          >
            <span>3</span>
          </div>
        </div>
        <div
          class="how-to-get-started-content"
          :class="{ 'step-2-active': showStep2, 'step-3-active': showStep3 }"
        >
          <img
            v-if="showStep2"
            src="../img/hts2.png"
            alt="Step 2"
            class="step2-image"
          />
          <div class="how-to-get-started-center" v-if="showStep3">
            <img src="../img/htg3.svg" alt="Step 3" class="step3-image" />
          </div>
          <div
            class="how-to-get-started-left"
            :class="{ 'step-2': showStep2, 'step-3': showStep3 }"
          >
            <div class="step-number">
              {{ showStep3 ? "3" : showStep2 ? "2" : "1" }}
            </div>
            <div class="step-text-container">
              <div v-if="!showStep2 && !showStep3" class="step-title">
                INSTALL RUST FROM AN<br />OFFICIAL SOURCE
              </div>
              <div v-if="showStep2" class="step-title">
                CONNECT TO THE SERVER
              </div>
              <div v-if="showStep3" class="step-title">JUMP IN AND PLAY</div>
              <div v-if="!showStep2 && !showStep3" class="step-subtitle">
                A legitimate copy is required to connect.
              </div>
              <div v-if="showStep2" class="step-subtitle">
                Copy IP:
                {{
                  $parent.ip && $parent.port
                    ? $parent.ip + ":" + $parent.port
                    : "0.000.0.000:00000"
                }}
              </div>
              <div v-if="showStep2" class="step-tip">
                Tip: In Rust, press F1 to open the console and run!
              </div>
              <div v-if="showStep3" class="step-subtitle">
                Explore, build, raid—and if you want a boost or fresh look,
                visit our shop for items, skins, and kits.
              </div>
            </div>
          </div>
          <img
            v-if="showStep2"
            src="../img/hts2_2.png"
            alt="Step 2 second"
            class="step2-image-2"
          />
          <div
            class="how-to-get-started-center"
            v-if="!showStep2 && !showStep3"
          >
            <img src="../img/htg.png" alt="How to get started" />
            <img src="../img/htgs.svg" alt="HTGS" class="htgs-svg" />
          </div>
        </div>
      </div>
    </div>

    <div class="section shop-preview-section" id="shop-preview">
      <div class="wrapper">
        <div class="title shop-preview-title">
          <img src="../img/Polygon2.svg" class="shop-preview-arrow-left" />
          <img src="../img/Polygonhead.svg" class="shop-preview-arrow-left" />
          THE RADGRIND SHOP
          <img src="../img/Polygonhead.svg" class="shop-preview-arrow-right" />
          <img src="../img/Polygon2.svg" class="shop-preview-arrow-right" />
        </div>
        <div class="shop-preview-subtitle">
          Upgrade your experience with optional, server-compatible items:
        </div>
        <div class="shop-preview-categories">
          <div class="shop-preview-category">
            <div class="shop-preview-category-title">
              • TOOLS, FOOD AND OTHER SKINS
            </div>
          </div>
          <div class="shop-preview-category">
            <div class="shop-preview-category-title">• COSMETIC SKINS</div>
          </div>
          <div class="shop-preview-category">
            <div class="shop-preview-category-title">
              • UTILITY ITEMS TO RESPECT SERVER BALANCE
            </div>
          </div>
        </div>
        <div class="shop-preview-items">
          <div class="shop-preview-item-wrapper">
            <img src="../img/TRS.png" alt="TRS" class="shop-preview-item" />
          </div>
        </div>
        <router-link to="/products" class="shop-preview-button">
          BROWSE SHOP
        </router-link>
      </div>
    </div>

    <div class="section faq-section" id="faq" ref="faqSection">
      <div class="wrapper">
        <div class="title faq-title">
          <img src="../img/Polygon2.svg" class="faq-arrow-left" />
          <img src="../img/Polygonhead.svg" class="faq-arrow-left" />
          FAQ
          <img src="../img/Polygonhead.svg" class="faq-arrow-right" />
          <img src="../img/Polygon2.svg" class="faq-arrow-right" />
        </div>
        <div class="accordion">
          <div v-for="(item, index) in $parent.faq" :key="index">
            <div :class="['item', { active: isActivePanel(index) }]">
              <div class="panel" @click="togglePanel(index)">
                <img src="./../img/faq.svg" class="plus" />
                <img src="./../img/faq/minus.svg" class="minus" />
                <div class="desc question">
                  <b>{{ item.question }}</b>
                </div>
              </div>
            </div>
            <div class="desc answer" v-if="isActivePanel(index)">
              {{ item.answer }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section rules-section">
      <div class="wrapper">
        <div class="title rules-title">
          <img src="../img/Polygon2.svg" class="rules-arrow-left" />
          <img src="../img/Polygonhead.svg" class="rules-arrow-left" />
          SERVER RULES
          <img src="../img/Polygonhead.svg" class="rules-arrow-right" />
          <img src="../img/Polygon2.svg" class="rules-arrow-right" />
        </div>
        <div class="rules-content">
          <div class="rules-left">
            <div class="rules-list">
              <div class="rule-item">
                <div class="rule-number">1.</div>
                <div class="rule-content">
                  <div class="rule-title">RESPECT EVERYONE</div>
                  <div class="rule-desc">
                    Harassment, hate speech, and targeted abuse are not
                    tolerated.
                  </div>
                </div>
              </div>
              <div class="rule-item">
                <div class="rule-number">2.</div>
                <div class="rule-content">
                  <div class="rule-title">NO CHEATS, HACKS, OR EXPLOITS</div>
                  <div class="rule-desc">
                    Don't use or promote third-party tools or game exploits.
                    Report vulnerabilities privately.
                  </div>
                </div>
              </div>
              <div class="rule-item">
                <div class="rule-number">3.</div>
                <div class="rule-content">
                  <div class="rule-title">PROTECT PRIVACY</div>
                  <div class="rule-desc">
                    Do not share personal information about yourself or other
                    players.
                  </div>
                  <div class="rule-desc">
                    Rule enforcement is at admin discretion to keep gameplay
                    fair and fun for all.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="rules-right">
            <img
              src="../img/serverules.png"
              class="rules-image"
              alt="Server Rules"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="section join-today-section">
      <div class="wrapper">
        <div class="title join-today-title">
          <img src="../img/Polygon2.svg" class="join-today-arrow-left" />
          <img src="../img/Polygonhead.svg" class="join-today-arrow-left" />
          JOIN TODAY
          <img src="../img/Polygonhead.svg" class="join-today-arrow-right" />
          <img src="../img/Polygon2.svg" class="join-today-arrow-right" />
        </div>
        <div class="join-today-content">
          <div class="join-today-ip">
            <span class="status-dot"></span>
            <span class="ip-label">SERVER IP:</span>
            <span class="ip-address">{{
              $parent.ip && $parent.port
                ? $parent.ip + ":" + $parent.port
                : "0.000.0.000:00000"
            }}</span>
            <button
              class="copy-button"
              v-clipboard="
                $parent.ip && $parent.port
                  ? $parent.ip + ':' + $parent.port
                  : ''
              "
              v-clipboard:success="clipboardSuccessHandler"
            >
              <span>{{ copied ? "COPIED" : "COPY" }}</span>
              <img src="../img/copy.svg" class="copy-icon" />
            </button>
          </div>
          <div class="join-today-desc">
            Stay updated on wipes and events. Explore our guides, find
            teammates, and make your mark.
          </div>
        </div>
      </div>
    </div>

    <footer class="new-footer">
      <div class="footer-top">
        <div class="wrapper">
          <div class="footer-links">
            <a
              v-for="page in footerPages"
              :key="page.id"
              @click="$parent.goToPage(page)"
              class="footer-link"
            >
              {{ page.title.toUpperCase() }}
            </a>
          </div>
        </div>
      </div>
      <div class="footer-middle">
        <div class="wrapper">
          <div class="footer-column footer-column-left">
            <div class="footer-info">
              <div class="footer-info-item" v-if="companyName">
                <span class="footer-info-label">COMPANY NAME:</span>
                {{ companyName }}
              </div>
              <div class="footer-info-item" v-if="registrationNumber">
                <span class="footer-info-label">REGISTRATION NUMBER:</span>
                {{ registrationNumber }}
              </div>
              <div class="footer-info-item" v-if="address">
                <span class="footer-info-label">ADDRESS:</span> {{ address }}
              </div>
            </div>
          </div>
          <div class="footer-column footer-column-center">
            <router-link to="/" class="footer-logo">
              <img src="../img/footer logo.svg" class="footer-logo-img" />
            </router-link>
          </div>
          <div class="footer-column footer-column-right">
            <div class="footer-support">
              <div
                class="footer-support-email"
                v-if="$parent.settings && $parent.settings.support_email"
              >
                SUPPORT: {{ $parent.settings.support_email }}
              </div>
              <div class="footer-social-icons">
                <a
                  v-for="link in $parent.socials"
                  :key="link.image"
                  :href="link.link"
                  target="_blank"
                  class="footer-social-icon"
                >
                  <img :src="getSocialIcon(link.link)" :alt="link.link" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="wrapper">
          <div
            class="footer-copyright"
            v-if="$parent.settings && $parent.settings.copyright"
          >
            {{ $parent.settings.copyright }}
          </div>
          <div class="footer-payment-methods">
            <img
              src="../img/Mastercard.svg"
              class="payment-icon"
              alt="Mastercard"
            />
            <img src="../img/visa-pay.svg" class="payment-icon" alt="Visa" />
            <img
              src="../img/apple-pay.svg"
              class="payment-icon"
              alt="Apple Pay"
            />
            <img
              src="../img/google-pay.svg"
              class="payment-icon"
              alt="Google Pay"
            />
          </div>
        </div>
      </div>
    </footer>
  </main>
</template>
<script>
import Vue from "vue";
import Clipboard from "v-clipboard";
import acebookIcon from "../img/acebook.svg";
import instagramIcon from "../img/instagram.svg";
import steamIcon from "../img/steam.svg";
Vue.use(Clipboard);

export default {
  name: "Home",
  props: ["currency", "currencyCode"],
  components: {},
  data: function () {
    return {
      acebookIcon: acebookIcon,
      instagramIcon: instagramIcon,
      steamIcon: steamIcon,
      activePanels: [],
      copied: false,
      isMoving: false,
      startPosition: 0,
      isMoving2: false,
      startPosition2: 0,
      showStep2: false,
      showStep3: false,
      activeStep: 1,
    };
  },
  computed: {
    footerPages() {
      if (
        !this.$parent.textPageList ||
        !Array.isArray(this.$parent.textPageList)
      ) {
        return [];
      }
      const keywords = ["terms", "privacy", "cookie"];
      return keywords
        .map((keyword) => {
          return this.$parent.textPageList.find(
            (page) =>
              (page.slug && page.slug.toLowerCase().includes(keyword)) ||
              (page.title && page.title.toLowerCase().includes(keyword)),
          );
        })
        .filter((page) => page !== undefined);
    },
    companyName() {
      if (!this.$parent.settings || !this.$parent.settings.requisites)
        return "";
      const lines = this.$parent.settings.requisites.split("\n");
      return lines[0] || "";
    },
    registrationNumber() {
      if (!this.$parent.settings || !this.$parent.settings.requisites)
        return "";
      const match =
        this.$parent.settings.requisites.match(/Reg\.Code:\s*(\d+)/);
      return match ? match[1] : "";
    },
    address() {
      if (!this.$parent.settings || !this.$parent.settings.requisites)
        return "";
      const lines = this.$parent.settings.requisites.split("\n");
      const addressLine = lines.find((line) =>
        line.toLowerCase().includes("address:"),
      );
      if (addressLine) {
        return addressLine.replace(/address:/i, "").trim();
      }
      return "";
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getSocialIcon(link) {
      if (!link) return "";
      const linkLower = link.toLowerCase();

      if (linkLower.includes("facebook") || linkLower.includes("fb")) {
        return this.acebookIcon;
      }
      if (linkLower.includes("instagram")) {
        return this.instagramIcon;
      }
      if (linkLower.includes("steam")) {
        return this.steamIcon;
      }
      return this.acebookIcon;
    },
    isFacebookLink(link) {
      return (
        link &&
        (link.toLowerCase().includes("facebook") ||
          link.toLowerCase().includes("fb"))
      );
    },
    handleScroll() {
      const section = this.$refs.targetSection;
      const movableElement = this.$refs.movableElement;
      const movableElement2 = this.$refs.movableElement2;

      if (section && movableElement && movableElement2) {
        const rect = section.getBoundingClientRect();

        // Check if the section's top is at the top of the viewport
        if (rect.top <= 200 && rect.bottom > 0 && !this.isMoving) {
          this.isMoving = true;
          this.startPosition = window.scrollY;
        }

        // Move the element if the section is in view
        if (this.isMoving) {
          const scrollOffset = window.scrollY - this.startPosition;
          movableElement.style.transform = `translateX(-${scrollOffset}px) translateY(${scrollOffset}px)`;
          movableElement2.style.transform = `translateX(+${scrollOffset}px) translateY(${scrollOffset}px)`;
        }
      }
    },
    clipboardSuccessHandler() {
      let self = this;
      self.copied = true;
      setTimeout(() => {
        self.copied = false;
      }, 1200);
    },
    togglePanel(index) {
      if (this.isActivePanel(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1);
      } else {
        this.activePanels.push(index);
      }
    },
    isActivePanel(index) {
      return this.activePanels.includes(index);
    },
    showStep1Images() {
      this.showStep2 = false;
      this.showStep3 = false;
      this.activeStep = 1;
      console.log("Step 1 clicked, showStep2:", this.showStep2);
    },
    showStep2Images() {
      this.showStep2 = true;
      this.showStep3 = false;
      this.activeStep = 2;
      console.log("Step 2 clicked, showStep2:", this.showStep2);
    },
    showStep3Images() {
      this.showStep2 = false;
      this.showStep3 = true;
      this.activeStep = 3;
      console.log("Step 3 clicked, showStep3:", this.showStep3);
    },
  },
};
</script>
